/* eslint-disable @bigbinary/neeto/use-neetoui-classes */
import { forwardRef } from "react";

import { CircleHelp, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

const MenuButton = forwardRef((props, ref) => {
  const { t } = useTranslation();

  return (
    <button
      {...{ ref }}
      className="hover:bg-accent flex h-9 w-full items-center gap-2 rounded-md px-2.5 text-sm font-medium"
      data-testid="help-menu-button"
      type="button"
      {...props}
    >
      <CircleHelp size={18} />
      <span className="flex-grow text-start">
        {t("neetoMolecules.sidebar.help")}
      </span>
      <ChevronRight className="rtl:scale-x-[-1]" size={18} />
    </button>
  );
});

MenuButton.displayName = "HelpMenuButton";

export default MenuButton;
